"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApSnowplow = void 0;
var browser_tracker_1 = require("@snowplow/browser-tracker");
var browser_plugin_form_tracking_1 = require("@snowplow/browser-plugin-form-tracking");
var browser_plugin_link_click_tracking_1 = require("@snowplow/browser-plugin-link-click-tracking");
var ApSnowplow = /** @class */function () {
  function ApSnowplow(_a) {
    var _b = _a.appId,
      appId = _b === void 0 ? 'Appical_Now' : _b,
      _c = _a.environment,
      environment = _c === void 0 ? 'dev' : _c,
      _d = _a.userData,
      userData = _d === void 0 ? {} : _d,
      _e = _a.contextCustomerData,
      contextCustomerData = _e === void 0 ? {} : _e,
      _f = _a.contextProductData,
      contextProductData = _f === void 0 ? {} : _f,
      _g = _a.contextUserData,
      contextUserData = _g === void 0 ? {} : _g,
      _h = _a.trackerName,
      trackerName = _h === void 0 ? "cf" : _h,
      _j = _a.platform,
      platform = _j === void 0 ? "web" : _j,
      _k = _a.encodeBase64,
      encodeBase64 = _k === void 0 ? false : _k,
      _l = _a.newTrackerContexts,
      newTrackerContexts = _l === void 0 ? {
        webPage: true,
        session: true,
        browser: true
      } : _l;
    var _this = this;
    this._getVismaSnowplowUrl = function () {
      var snowplowUrls = {
        dev: "https://snowplow-test.visma.com",
        staging: "https://snowplow-test.visma.com",
        prod: "https://snowplow.visma.com"
      };
      return snowplowUrls[_this.environment];
    };
    this._getContext = function (type) {
      var schemas = {
        customer: "iglu:com.visma-tech-hubs/context_customer/jsonschema/1-0-0",
        product: "iglu:com.visma-tech-hubs/context_product/jsonschema/1-0-0",
        user: "iglu:com.visma-tech-hubs/context_user/jsonschema/1-0-0"
      };
      return {
        schema: schemas[type],
        data: _this.contexts[type]
      };
    };
    this._mainContext = function () {
      return [_this._getContext("customer"), _this._getContext("product"), _this._getContext("user")];
    };
    this.setIsActivityTrackingEnabled = function (isActivityTrackingEnabled) {
      _this.isActivityTrackingEnabled = isActivityTrackingEnabled;
    };
    this.setIsLinkClickTrackingEnabled = function (isLinkClickTrackingEnabled) {
      _this.isLinkClickTrackingEnabled = isLinkClickTrackingEnabled;
    };
    this.setIsFormTrackingEnabled = function (isFormTrackingEnabled) {
      _this.isFormTrackingEnabled = isFormTrackingEnabled;
    };
    this.setIsPageViewTrackingEnabled = function (isPageViewTrackingEnabled) {
      _this.isPageViewTrackingEnabled = isPageViewTrackingEnabled;
    };
    this._validateContextData(contextCustomerData, 'contextCustomerData');
    this._validateContextData(contextProductData, 'contextProductData');
    this._validateContextData(contextUserData, 'contextUserData');
    this.appId = appId;
    this.environment = environment;
    this.userData = userData;
    this.trackerName = trackerName;
    this.platform = platform;
    this.encodeBase64 = encodeBase64;
    this.newTrackerContexts = newTrackerContexts;
    this.contexts = {
      customer: contextCustomerData,
      product: contextProductData,
      user: contextUserData
    };
    this.vismaSnowplowUrl = this._getVismaSnowplowUrl();
    this.isActivityTrackingEnabled = false;
    this.isLinkClickTrackingEnabled = false;
    this.isFormTrackingEnabled = false;
    this.isPageViewTrackingEnabled = false;
  }
  /**
   * Get a singleton instance of the ApSnowplow class so it can be re-used across the app.
   *
   * @param config ApSnowplowConfig
   * @returns singleton instance
   */
  ApSnowplow.getInstance = function (config) {
    if (!ApSnowplow.instance) {
      ApSnowplow.instance = new ApSnowplow(config);
    }
    return ApSnowplow.instance;
  };
  /**
   * Update the configuration of the singleton instance.
   *
   * @param config ApSnowplowConfig
   */
  ApSnowplow.prototype.updateConfig = function (_a) {
    var _b = _a.appId,
      appId = _b === void 0 ? this.appId : _b,
      _c = _a.environment,
      environment = _c === void 0 ? this.environment : _c,
      _d = _a.userData,
      userData = _d === void 0 ? this.userData : _d,
      _e = _a.contextCustomerData,
      contextCustomerData = _e === void 0 ? this.contexts.customer : _e,
      _f = _a.contextProductData,
      contextProductData = _f === void 0 ? this.contexts.product : _f,
      _g = _a.contextUserData,
      contextUserData = _g === void 0 ? this.contexts.user : _g;
    this._validateContextData(contextCustomerData, 'contextCustomerData');
    this._validateContextData(contextProductData, 'contextProductData');
    this._validateContextData(contextUserData, 'contextUserData');
    this.appId = appId;
    this.environment = environment;
    this.userData = userData;
    this.contexts = {
      customer: contextCustomerData,
      product: contextProductData,
      user: contextUserData
    };
  };
  /**
   * Reset the singleton instance.
   */
  ApSnowplow.resetInstance = function () {
    ApSnowplow.instance = null;
  };
  /**
   * Validates the context data.
   *
   * @param contextData - The context data to validate.
   * @param contextName - The name of the context.
   * @throws {Error} If the contextData is not an object or null.
   * @throws {Error} If any value in the contextData is not a string.
   */
  ApSnowplow.prototype._validateContextData = function (contextData, contextName) {
    if (typeof contextData !== 'object' || contextData === null) {
      throw new Error("".concat(contextName, " must be an object"));
    }
    for (var key in contextData) {
      if (key === 'registration_date') {
        if (!(typeof contextData[key] !== 'string' || contextData[key] !== null)) {
          throw new Error("The value for the registration_date must be string or null. Found ".concat(typeof contextData[key], " for key \"").concat(key, "\"."));
        }
      } else if (typeof contextData[key] !== 'string') {
        throw new Error("All values in ".concat(contextName, " must be strings. Found ").concat(typeof contextData[key], " for key \"").concat(key, "\"."));
      }
    }
  };
  ApSnowplow.prototype.init = function () {
    var _a;
    (0, browser_tracker_1.newTracker)(this.trackerName, this.vismaSnowplowUrl, {
      appId: this.appId,
      encodeBase64: this.encodeBase64,
      platform: this.platform,
      contexts: this.newTrackerContexts,
      plugins: [(0, browser_plugin_form_tracking_1.FormTrackingPlugin)()]
    });
    if ((_a = this.userData) === null || _a === void 0 ? void 0 : _a.id) {
      (0, browser_tracker_1.setUserId)(this.userData.id);
    }
    if (this.isLinkClickTrackingEnabled) {
      (0, browser_plugin_link_click_tracking_1.enableLinkClickTracking)({
        context: this._mainContext(),
        pseudoClicks: true,
        trackContent: true
      });
    }
    if (this.isFormTrackingEnabled) {
      (0, browser_plugin_form_tracking_1.enableFormTracking)({
        options: {},
        context: this._mainContext()
      });
    }
    if (this.isActivityTrackingEnabled) {
      (0, browser_tracker_1.enableActivityTracking)({
        minimumVisitLength: 30,
        heartbeatDelay: 10
      });
    }
    if (this.isPageViewTrackingEnabled) {
      (0, browser_tracker_1.trackPageView)({
        title: document.title || null,
        context: this._mainContext()
      });
    }
  };
  /**
   * Make the structured event tracking aviailable to the app.
   * @param category string
   * @param action string
   * @param label string
   * @param property string
   * @param value number | undefined
   */
  ApSnowplow.prototype.trackCustomStructEvent = function (category, action, label, property, value) {
    (0, browser_tracker_1.trackStructEvent)({
      category: category,
      action: action,
      label: label,
      property: property,
      value: value !== null && value !== void 0 ? value : undefined,
      context: this._mainContext()
    });
  };
  return ApSnowplow;
}();
exports.ApSnowplow = ApSnowplow;